import React, { useContext, useEffect, useState } from "react";

import "./stylesCampaignDetails.css";
import AppContext from "../../../../context/AppContext";
import { KPI_CARD_BACKGROUND, SIDER_TABS } from "../../../../utils/Constants";

import CustomDatePicker from "../../../CommonComponents/CustomDatePicker/CustomDatePicker";

import CustomAutoComplete from "../../../CommonComponents/CustomAutoComplete/CustomAutoComplete";
import { Select, Table } from "antd";
import {
  CaretDownOutlined,
  CaretLeftOutlined,
  CaretUpOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import Avatar from "../../../../assets/avatar/avatar.png";
import Purchases from "./Purchases/Purchases";

import "./stylesCampaignDetails.css";
import PromotionDetails from "./PromotionDetails/PromotionsDetails";
import DashboardPieChart from "../../../CommonComponents/Dashboard/DashboardPieChart/DashboardPieChart";
import KpiCard from "../../../CommonComponents/Dashboard/KpiCard/KpiCard";
import { AppStrings } from "../../../../utils/constants/AppStrings";
import { usePageTitle } from "../../../CommonComponents/Layout/PageTitleContext";
import { getAdminNow } from "../../../../utils/dateService";

const emails = [
  {
    id: 1,
    label: "alice.johnson@example.com",
    value: "alice.johnson@example.com",
  },
  {
    id: 2,
    label: "bob.smith@example.com",
    value: "bob.smith@example.com",
  },
  {
    id: 3,
    label: "charlie.davis@example.com",
    value: "charlie.davis@example.com",
  },
  {
    id: 4,
    label: "diana.evans@example.com",
    value: "diana.evans@example.com",
  },
  {
    id: 5,
    label: "edward.brown@example.com",
    value: "edward.brown@example.com",
  },
];

const columns = [
  {
    title: AppStrings.PLAYER_ID,
    dataIndex: "playerId",
    key: "playerId",
    sorter: (a, b) => a.playerId - b.playerId,
  },
  {
    title: AppStrings.PLAYER_NAME,
    dataIndex: "playerName",
    key: "playerName",
    sorter: (a, b) => a.playerName.localeCompare(b.playerName),
    render: (_, record) => (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <img
          src={Avatar}
          alt={record.playerName}
          style={{ borderRadius: "50%" }}
        />
        <span>{record.playerName}</span>
      </div>
    ),
  },
  {
    title: AppStrings.PURCHASES,
    dataIndex: "purchases",
    key: "purchases",
    sorter: (a, b) => a.purchases - b.purchases,
    render: (value) => (
      <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        {value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        })}
      </span>
    ),
  },
  {
    title: AppStrings.PAID_OUT,
    dataIndex: "paidOut",
    key: "paidOut",
    sorter: (a, b) => a.paidOut - b.paidOut,
    render: (value) => (
      <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        {value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        })}
        <p className="up">
          <CaretUpOutlined /> 10%
        </p>
      </span>
    ),
  },
  {
    title: AppStrings.PROFIT,
    dataIndex: "profit",
    key: "profit",
    sorter: (a, b) => a.profit - b.profit,
    render: (value) => (
      <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        {value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        })}
        <p className="up">
          <CaretUpOutlined /> 15%
        </p>
      </span>
    ),
  },
  {
    title: AppStrings.BONUS_AMOUNT,
    dataIndex: "bonusAmount",
    key: "bonusAmount",
    sorter: (a, b) => a.bonusAmount - b.bonusAmount,
    render: (value) =>
      value.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      }),
  },
  {
    title: AppStrings.TRANSACTION_DATES,
    dataIndex: "transactionDates",
    key: "transactionDates",
    sorter: (a, b) =>
      new Date(a.transactionDates) - new Date(b.transactionDates),
  },
  {
    title: AppStrings.STATUS,
    dataIndex: "status",
    key: "status",
    sorter: (a, b) => a.status.localeCompare(b.status),
    render: (text) => (
      <span className={`status ${text.toLowerCase()}`}>{text}</span>
    ),
  },
  {
    title: AppStrings.EMAIL,
    dataIndex: "email",
    key: "email",
    sorter: (a, b) => a.email.localeCompare(b.email),
  },
  {
    title: AppStrings.EVENT_USED_ON,
    dataIndex: "eventUsedOn",
    key: "eventUsedOn",
    sorter: (a, b) => a.eventUsedOn.localeCompare(b.eventUsedOn),
  },
];

const dataSource = [
  {
    key: "1",
    playerId: 1001,
    playerName: "Alice Johnson",
    purchases: 5,
    paidOut: 150,
    profit: 320,
    bonusAmount: 50,
    transactionDates: "2025-04-01",
    status: "Approved",
    email: "alice.johnson@example.com",
    eventUsedOn: "Spring Promo",
  },
  {
    key: "2",
    playerId: 1002,
    playerName: "Bob Smith",
    purchases: 3,
    paidOut: 75,
    profit: 180,
    bonusAmount: 20,
    transactionDates: "2025-03-28",
    status: "Rejected",
    email: "bob.smith@example.com",
    eventUsedOn: "Lucky Spin",
  },
  {
    key: "3",
    playerId: 1003,
    playerName: "Charlie Davis",
    purchases: 8,
    paidOut: 200,
    profit: 500,
    bonusAmount: 80,
    transactionDates: "2025-04-05",
    status: "Approved",
    email: "charlie.davis@example.com",
    eventUsedOn: "Mega Bonus",
  },
  {
    key: "4",
    playerId: 1004,
    playerName: "Diana Evans",
    purchases: 2,
    paidOut: 30,
    profit: 100,
    bonusAmount: 15,
    transactionDates: "2025-03-22",
    status: "Approved",
    email: "diana.evans@example.com",
    eventUsedOn: "Welcome Offer",
  },
  {
    key: "5",
    playerId: 1005,
    playerName: "Edward Brown",
    purchases: 4,
    paidOut: 120,
    profit: 250,
    bonusAmount: 40,
    transactionDates: "2025-03-30",
    status: "Rejected",
    email: "edward.brown@example.com",
    eventUsedOn: "VIP Rewards",
  },
];

const getPieData = () => [
  {
    device: AppStrings.PLAYERS_RECEIVED,
    count: 120000,
    color: "#4CAF50",
  },
  {
    device: AppStrings.PLAYERS_USED,
    count: 90000,
    color: "#FF9800",
  },
];

function CampaignDetails() {
  usePageTitle(AppStrings.PAM_PROMOTION_CAMPAIGN_DETAILS_TITLE);

  const navigate = useNavigate();

  const { setActiveSidebarTab } = useContext(AppContext);

  const todayRange = [getAdminNow(), getAdminNow()];
  const [dates, setDates] = useState(todayRange);

  const [selectedEmail, setSelectedEmail] = useState(null);
  const [filteredData, setFilteredData] = useState(dataSource);

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.PROMOTIONS, "BONUS_CONTROLS");
  }, []);

  useEffect(() => {
    if (!selectedEmail) {
      setFilteredData(dataSource);
    } else {
      const filtered = dataSource.filter(
        (item) => item.email === selectedEmail
      );
      setFilteredData(filtered);
    }
  }, [selectedEmail]);

  return (
    <>
      <div className="promotions-management-container campaign-details">
        <div className="promotions-management">
          <>
            <div className="head-controls">
              <div className="header-text-container">
                <div
                  className="header-back-button"
                  onClick={() => navigate(-1)}
                >
                  <LeftOutlined className="header-back-button-icon" />
                </div>
              </div>
            </div>
            <div className="promotions-management-content">
              <div className="top-content">
                <div className="left-content">
                  <div className="kpi-cards-container">
                    <KpiCard
                      isApiRunning={false}
                      title={AppStrings.PURCHASES}
                      value={236999}
                      hugeValue={false}
                      percentage={88}
                      backgroundColor={KPI_CARD_BACKGROUND.DARK}
                      customText={AppStrings.PAM_PROMOTIONS_FROM_TOTAL_VOLUME}
                    />
                    <KpiCard
                      isApiRunning={false}
                      title={AppStrings.PAID_OUT}
                      value={112036}
                      hugeValue={false}
                      percentage={-54}
                      backgroundColor={KPI_CARD_BACKGROUND.DARK}
                      customText={AppStrings.PAM_PROMOTIONS_FROM_TOTAL_WAGERED}
                    />
                    <KpiCard
                      isApiRunning={false}
                      title={AppStrings.PROFIT}
                      value={900}
                      hugeValue={false}
                      percentage={-46}
                      backgroundColor={KPI_CARD_BACKGROUND.DARK}
                      customText={AppStrings.PAM_PROMOTIONS_FROM_TOTAL_WAGERED}
                    />
                  </div>
                  <Purchases />
                  <div style={{width: "100%"}}>
                    <DashboardPieChart title={AppStrings.PROMO_USAGE} pieData={getPieData()} />
                  </div>
                </div>
                <div className="right-content">
                  <PromotionDetails />
                </div>
              </div>
              <div className="promotions-management-table-container">
                <div className="promotions-management-table-container-header">
                  <h2>{AppStrings.PROMO_PARTICIPANTS}</h2>
                  <CustomDatePicker
                    getData={() => {}}
                    dates={dates}
                    setDates={setDates}
                    showPresets={true}
                  />
                </div>
                <div className="promotions-management-selector-container">
                  <div className="promotions-management-selector">
                    <Select
                      mode="single"
                      placeholder={AppStrings.SEARCH_BY_EMAIL}
                      onChange={(value) => setSelectedEmail(value)}
                      options={emails}
                    />
                  </div>
                  <CustomAutoComplete
                    placeholder={AppStrings.SEARCH}
                    allOptions={emails}
                    handleChange={(value) => setSelectedEmail(value)}
                    clearOptions={() => setSelectedEmail(null)}
                  />
                </div>
                <div className="promotions-management-table">
                  <Table
                    dataSource={filteredData}
                    columns={columns}
                    scroll={{ x: 1700 }}
                  />
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
}

export default CampaignDetails;
